var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-autocomplete',{attrs:{"items":_vm.items,"item-text":"family","label":"Choose Font","value":_vm.value,"solo":"","dark":""},on:{"change":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('span',{style:({
               fontFamily: data.item.family,
               fontSize: '15px'
           })},[_vm._v(_vm._s(data.item.family))])]}},{key:"item",fn:function(ref){
           var item = ref.item;
           var index = ref.index;
return [_c('v-list-item-content',[_c('span',{style:({
               fontFamily: item.family,
               fontSize: '25px'
           })},[_vm._v(_vm._s(item.family))])])]}}],null,false,719481820)}):_c('v-progress-circular',{attrs:{"color":"orange","indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }